export default __webpack_public_path__ + "static/media/IN.a61ac1fd.svg";